<script>
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionKey } from "../context/cinemaTileDimension";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        image,
        variationId = null,
        lazyLoad = false,
        isVeryPopular = false,
        personalisedUser = false,
        fromCardRecommendation = false,
        showWishlistHeartButton = false,
        feature = null,
    } = $props();

    const tileDimensions = getContext(cinemaTileDimensionKey);
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule.js";
    const dresonRule = getContext(contentDresonRuleCtxKey);

    const MEDIUM_IMAGE_SIZE_PRESET = "$spa_ambiente$";
    const TILE_PORTRAIT_PRESET = "$tile_portrait$";
    const loadingValue = lazyLoad ? "lazy" : "eager";

    const buildImageUrl = (imageUrl, clippingType) => {
        const prefix = clippingType === "AMBIENTE" ? MEDIUM_IMAGE_SIZE_PRESET : TILE_PORTRAIT_PRESET;
        return imageUrl + "?" + prefix;
    };

    const imageSrc = $derived(buildImageUrl(image._links.external.href, image.clippingType));

    const wishlistButtonClickListener = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
</script>

<div
    class:reco_cinema__image={!fromCardRecommendation}
    class:reco_card_cinema__image={fromCardRecommendation}
    style:min-height={`${tileDimensions.minimumHeight}px`}
    style:aspect-ratio="3 / 4"
>
    <picture>
        <source srcset="{imageSrc}&fmt=auto" />
        <img
            loading={loadingValue}
            data-src={imageSrc}
            src={lazyLoad ? "" : imageSrc}
            alt={image.altText}
            class="{lazyLoad ? 'lazy' : ''} {image.clippingType === 'AMBIENTE' ? 'ambiente' : 'cutout'}"
            data-testid="image-title"
        />
    </picture>
    <div class="reco_cinema__image__spinner_box">
        <div class="reco_cinema__image__spinner {lazyLoad ? 'p_loader250' : ''}"></div>
    </div>

    <ft9-productbadge-v1
        team="ft6-bcn"
        feature="recoProductCampaignFlag"
        variation-id={variationId}
        context-dreson={dresonRule ?? "(und.(ja).(~.(v.1)))"}
        personalized-reco={personalisedUser}
        class="reco_cinema__ft9_deal_badge"
    >
    </ft9-productbadge-v1>
    {#if showWishlistHeartButton}
        <ofc-wishlist-save-button-v1
            class="reco_cinema__wishlist_save_button"
            variation-id={variationId}
            qualified="true"
            source={feature}
            onclick={wishlistButtonClickListener}
            ignoreOnex
        >
        </ofc-wishlist-save-button-v1>
    {/if}
    <div class="reco_cinema__labels_wrapper">
        {#if isVeryPopular}
            <div class="reco_cinema__label-visibility reco_cinema__very-popular-tag">
                <oc-tag-v1 size="50" variant="info-primary">Sehr beliebt</oc-tag-v1>
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .reco_cinema__image {
        text-align: center;
        padding-bottom: initial;
        position: relative;
        overflow: hidden;
        max-height: 100%;
        max-width: 100%;

        img {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            right: 50%;
            transform: translate(50%, 0);
        }

        img.ambiente {
            width: auto;
            height: auto;
            min-width: 100%;
            min-height: 100%;
            max-width: none;
        }

        img.cutout {
            padding: 8px;
            width: 100%;
            border-radius: var(--oc-semantic-border-radius-200);
        }
    }

    .reco_card_cinema__image {
        display: block;
        height: 100%;
        width: 100%;
        position: relative;
        overflow: hidden;
        max-width: 100%;

        img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: inherit;
            display: block;
            max-width: 100%;
            max-height: 100%;
        }

        img.ambiente {
            min-width: 100%;
            min-height: 100%;
            max-width: none;
            border-radius: 12px;
        }

        img.cutout {
            padding: 8px;
            border-radius: 12px;
        }
    }

    .reco_cinema__image__spinner_box {
        position: absolute;
        margin: auto;
        width: 60px;
        height: 60px;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: -1;
    }

    .reco_cinema__labels_wrapper {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 16px;
        left: 16px;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    .reco_cinema__label-visibility {
        z-index: 1;
    }

    .reco_cinema__very-popular-tag {
        margin-top: 8px;
    }

    .reco_cinema__ft9_deal_badge {
        position: absolute;
        width: 50px;
        height: 50px;
        z-index: 1;
        top: 12px;
        left: 12px;
        border: none;
        cursor: pointer;
    }

    .reco_cinema__wishlist_save_button {
        position: absolute;
        z-index: 2;
        top: 8px;
        right: 8px;
        border: none;
        cursor: pointer;
    }
</style>
